import { render } from "./Note.vue?vue&type=template&id=e1343e8e"
import script from "./Note.vue?vue&type=script&lang=js"
export * from "./Note.vue?vue&type=script&lang=js"
script.render = render

export default script